export const REDACTED = "REDACTED";

export const PII_FIELDS = ["fullName", "email"] as const;

export const fieldRebateAccountID = "rebateAccountID";

export const CLIENT_TRADING_TABLE_FILTER_REPORT_START_DATE =
  "2021-01-01T00:00:00";
